import React from "react";
import { Container, MainGrid } from "./Dashboard.styles";
import { FlightChangesCases } from "../FlightChangesCases/flightChangesCase";
import { FlightChangesCasesSkeleton } from "../FlightChangesCases/FlightChangesCasesSkeleton";
import { RoleProtectedRoute } from "../../components/auth";

export const Dashboard: React.FC = () => (
  <Container>
    <MainGrid>
      <RoleProtectedRoute
        requiredRoles={["admin", "supervisor", "agente"]}
        skipAuthCheck
        loadingFallback={<FlightChangesCasesSkeleton />}
      >
        <FlightChangesCases />
      </RoleProtectedRoute>
    </MainGrid>
  </Container>
);